import { Link } from '@delmonicos/shared-design-system-react/src/components/link/link';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { GatewayChargingSessionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/charging-sessions/gateway-charging-session.model';
import { CellContext } from '@tanstack/react-table';
import { generatePath, useNavigate } from 'react-router-dom';

import { APP_PATH } from '@app/config/app-paths';

export interface EmspBoChargingSessionListSessionIdCellProps
  extends CellContext<
    GatewayChargingSessionModel,
    GatewayChargingSessionModel['sessionId']
  > {}

export const EmspBoChargingSessionListSessionIdCell = (
  props: EmspBoChargingSessionListSessionIdCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue, row } = props;
  const navigate = useNavigate();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Link
      onClick={() =>
        navigate(
          generatePath(APP_PATH.EMSP_BO_CHARGING_SESSION.DETAILS, {
            id: row.original.id,
          }),
        )
      }
      fullWidth>
      <Text truncate>{getValue()}</Text>
    </Link>
  );
};
